// extracted by mini-css-extract-plugin
export default {"button":"CartButton_button__o5Wko","badge":"CartButton_badge__3L5gC"};